if (document.getElementById('vue-apply')) {
	Vue.use(VeeValidate)
	new Vue({
		mixins: [baseMixin, eventHubMixin, apiMixin, MobileValidate],
		el: '#vue-apply',
		data: {
			loading: false,
			fullForm: false,
			attachment: null,
			drop_attachment: null,
			form_fields: {
				first_name: '',
				last_name: '',
				phone: '',
				email: '',
				linkedin: '',
				message: ''
			}
		},
		mounted() {},
		created() {
			this.$validator.extend('phone', MobileValidate)
		},

		methods: {
			classesValidation(scope, key) {
				return {
					'is-valid': Object.keys(this.fields).length
						? !this.errors.has(key, scope) &&
						  this.fields['$' + scope][key] &&
						  this.fields['$' + scope][key].valid &&
						  this[key] != '' &&
						  this.fields['$' + scope][key].validated
						: false,
					'is-error': this.errors.has(key, scope)
				}
			},

			hasError(scope) {
				return (
					this.errors.items.length &&
					this.errors.items.some((el) => el.scope === scope)
				)
			},

			// toggleFullForm() {
			//     this.fullForm = !this.fullForm;
			// },

			submit(event, form) {
				this.$validator.validateAll(form).then((result) => {
					if (result) {
						this.loading = true

						let data = this.getFormData(
							event,
							form === 'drop_form' ? 'drop_attachment' : 'attachment'
						)

						axios
							.post(ajaxurl, data)
							.then(() => {
								this.clearForm()
								this.eventHub.$emit('notifications:addSuccess')
								this.sendDataToAnalytics()
							})
							.catch((error) => {
								// console.log(error);
							})
							.finally(() => {
								this.loading = false
							})
					} else {
						this.eventHub.$emit('notifications:addError')
					}
				})
			},

			getFormData(event, attachment) {
				let data = new FormData()
				data.append('action', 'broadbean_apply')
				data.append('attachment', this[attachment])
				data.append('application-email', event.target.dataset.email)
				data.append('job', event.target.dataset.job)

				Object.keys(this.form_fields).forEach((key) => {
					data.append(key, this.form_fields[key])
				})

				return data
			},

			clearForm() {
				this.form_fields = {
					first_name: '',
					last_name: '',
					phone: '',
					email: '',
					linkedin: '',
					message: ''
				}

				this.attachment = null
				this.drop_attachment = null
				this.$validator.reset()
			},

			updateFile(event, key = 'attachment') {
				this[key] = event.target.files[0]
			},

			dropCV() {
				gtag('event', 'click', {
					'event_category': 'Curriculum Vitae',
					'event_label': 'Clic sur le bouton de dépôt de CV'
				});
			},

			sendDataToAnalytics() {
				gtag('event', 'submit', {
					'event_category': 'Formulaire de dépôt',
					'event_label': 'Validation du formulaire de dépôt'
				});
			}
		}
	})
}
